module.exports = __webpack_public_path__ + "static/img/no_cover.e421434e.png";